import api from "@/services/api"

export type ChangeSupervisorPin = {
  pin: string
}

export const changeSupervisorPin = async (
  payload: ChangeSupervisorPin
): Promise<unknown> => {
  const { body } = await api.post(
    "/change-supervisor-pin/",
    { body: payload }
  )
  return body
}
